<template>
<div>
Glossary of terms
</div>
</template>

<script>
export default {
  name: 'GlossaryPage',
}
</script>

<style scoped>
#header{
        margin-top: 40px;
      }
p {
        text-align: justify;
      }
#introduction{
        margin-top: 30px;

}

</style>
